import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router'
import { AuthProvider } from '@/auth/AuthProvider'
import { EmailLinkPage } from '@/auth/EmailLinkPage'
import { InvitePage } from '@/auth/InvitePage'
import { AccountPage } from '@/auth/AccountPage'
import { SignInPage } from '@/auth/SignInPage'
import { RequireAuth, RequireStaff } from '@/auth/guards'
import { ClientPicker } from '@/client/ClientPicker'
import { ClientRoutes } from '@/client/ClientRoutes'
import { ConfirmProvider, ToastProvider } from '@/ui'
import { Home } from './Home'

const StaffRoutes = lazy(() => import('@/staff/StaffRoutes').then((m) => ({ default: m.StaffRoutes })))
const TokensPage = import.meta.env.DEV ? lazy(() => import('@/dev/TokensPage').then((m) => ({ default: m.TokensPage }))) : null

export function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <ConfirmProvider>
        <a href="#main" className="skip-link">
          Skip to content
        </a>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/sign-in" element={<SignInPage />} />
            <Route path="/auth/email-link" element={<EmailLinkPage />} />
            <Route path="/invite/:inviteId" element={<InvitePage />} />
            {TokensPage && <Route path="/dev/tokens" element={<TokensPage />} />}
            <Route element={<RequireAuth />}>
              <Route path="/" element={<Home />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/clients" element={<ClientPicker />} />
              <Route path="/c/:clientId/*" element={<ClientRoutes />} />
              <Route element={<RequireStaff />}>
                <Route path="/staff/*" element={<StaffRoutes />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
        </ConfirmProvider>
      </ToastProvider>
    </AuthProvider>
  )
}
